import React from 'react';
import { ReactComponent as Logo } from 'src/styles/themes/expretio-rivalis/assets/svg/logo.svg';
import { ReactComponent as BigLogo } from 'src/styles/themes/expretio-rivalis/assets/svg/company-logo.svg';

type RivalisLogoProps = {
  collapsed: boolean;
};

export const RivalisLogo: React.FC<RivalisLogoProps> = ({ collapsed }) => {
  return collapsed ? <Logo /> : <BigLogo />;
};
